import gql from 'graphql-tag'

export const GET_COMPANY = gql`
query Company($filter: GetCompanyInput!) {
    company(filter: $filter) {
      isSuccessful
      message
      company {
        id
        name
        dsInitialBonus
        dsIntervalType
        dsInitialInterval
        dsInitialBonus
        dsInterval
        dsBonus
        dsCostBrake
        dsCostAccel
        dsCostOverspeed
        dsCostSharpturn
        dsMinScoreA
        dsMinScoreB
        dsMinScoreC
        dsMinScoreD
      }
    }
}
`

export const UPDATE_COMPANY_CONFIGURATION = gql`
mutation UpdateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    company {
      dsCostSharpturn
      dsCostOverspeed
      dsCostAccel
      dsCostBrake
      dsBonus
      dsInterval
      dsInitialBonus
      dsIntervalType
      dsInitialInterval
      dsBase
    }
    isSuccessful
    message
  }
}
`
